// Module
var code = "<h1 id=\"roles\">Roles</h1> <p>This tab is to view what permissions a role on the system has.</p> <p>Select a role and you will be able to filter and see what that specific role can do on the SIS with the permissions they have.</p> <p><em>Note</em>: You cannot change any existing permissions for a role.</p> ";
// Exports
module.exports = code;